import styled from 'styled-components';
import { DEVICES } from '_constants';

export const Title = styled.div`
  margin: 0 0 0 8px;
  display: none;
`;

export const CellWrapper = styled.button`
  /* Buttons do not inherit colour; without this the icon/label falls back to the UA's black. */
  color: var(--text-strong);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: transparent;
  cursor: pointer;

  @media ${DEVICES.tableView} {
    width: max-content;
    margin: 0 0 0 auto;

    ${Title} {
      display: block;
    }
  }
`;
